import React, { useState } from 'react';
import axios from 'axios';
import { History } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { DeleteRequestButton } from './DeleteRequestButton';

export const RequestHistory = ({ scope = 'general', onChange }) => {
  const { token, user } = useAuth();
  const [open, setOpen] = useState(false), [rows, setRows] = useState([]), [error, setError] = useState(''), [loading, setLoading] = useState(false);
  if (!['hr_admin', 'super_admin'].includes(user?.role)) return null;
  const load = async () => {
    setLoading(true); setError('');
    try { const r = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/request-tools/${scope}/audit-history`, { headers: { Authorization: `Bearer ${token}` } }); setRows(r.data.items); }
    catch { setError('Audit history could not be loaded'); }
    finally { setLoading(false); }
  };
  return <>
    <Button variant="outline" onClick={() => { setOpen(true); load(); }} data-testid={`${scope}-audit-history-button`}><History className="me-2 h-4 w-4" />Audit history</Button>
    <Dialog open={open} onOpenChange={setOpen}><DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto" data-testid={`${scope}-audit-history-dialog`}>
      <DialogHeader><DialogTitle>Request audit history</DialogTitle><DialogDescription>Cancelled and deleted records</DialogDescription></DialogHeader>
      {loading && <p data-testid={`${scope}-audit-history-loading`}>Loading…</p>}
      {error && <p role="alert" className="text-red-700" data-testid={`${scope}-audit-history-error`}>{error}</p>}
      {!loading && !rows.length && <p data-testid={`${scope}-audit-history-empty`}>No archived records.</p>}
      {rows.map(row => <div className="border-b py-3 min-w-0" key={row.id} data-testid={`history-${scope}-${row.id}`}>
        <div className="flex flex-wrap items-center justify-between gap-2"><p className="font-medium break-all">{row.title || 'Request'} · {row.id.slice(0, 8)}</p><span className="text-xs text-slate-500">{row.archive_action === 'delete' ? 'Deleted' : 'Cancelled'}</span></div>
        <p className="text-sm break-words text-slate-600">{row.archive_reason || row.cancellation_reason || 'No reason recorded'}</p>
        <DeleteRequestButton scope={scope} row={row} prefix="history" onDeleted={() => { load(); onChange?.(); }} />
      </div>)}
    </DialogContent></Dialog>
  </>;
};